<template>
  <v-dialog
    v-if="modalZoomimg"
    v-model="modalZoomimg"
    content-class="dialogimgview"
    persistent
  >
    <v-card style="background-color: transparent !important; box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important;">
      <v-card-text
        class="imgview">
        <v-img
          :src="editimgzoom"
          @click="closeModal('Zoomimg')"
      /></v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

export default {
  data: () => ({

  }),
  computed: {
    ...mapGetters(['modalZoomimg', 'editimgzoom'])
  },
  methods: {
    ...mapActions(['closeModal'])
  }
}
</script>

<style lang="scss">
.v-dialog.dialogimgview{
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important;
}
.imgview{
  padding: 0 0 0 0 !important;
  height: 70vh !important;
  text-align: center;
  v-img{
    border-radius: 7px !important;
    height: 70vh !important;
  }
}
</style>
